import { alpha, createStyles, Theme } from '@material-ui/core/styles';

import { colours } from '@shared/theme/colours';

export const styles = ({ spacing }: Theme) =>
  createStyles({
    root: {
      display: 'inline-flex',
      position: 'relative',
    },
    outstandingDot: {
      background: colours.brandSalmon[500],
      borderRadius: '50%',
      boxShadow: `0 0 0 1.5px ${colours.solid.white}`,
      height: 10,
      pointerEvents: 'none',
      position: 'absolute',
      right: 7,
      top: 7,
      width: 10,
    },
    popoverPaper: {
      border: `1px solid ${colours.neutral[200]}`,
      borderRadius: 12,
      boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.1)',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      width: 480,
    },
    navItemRoot: {
      width: '100%',
    },
    navItem: {
      alignItems: 'center',
      background: 'none',
      border: 'none',
      borderRadius: 6,
      color: alpha(colours.solid.white, 0.65),
      cursor: 'pointer',
      display: 'flex',
      fontFamily: 'inherit',
      gap: 8,
      height: 40,
      padding: spacing(2.5, 2),
      stroke: alpha(colours.solid.white, 0.65),
      transition: 'background-color 0.4s ease, stroke 0.4s, color 0.4s ease',
      width: '100%',
      '&:hover': {
        background: alpha(colours.solid.white, 0.15),
        color: colours.solid.white,
        stroke: colours.solid.white,
      },
    },
    navItemIcon: {
      display: 'inline-flex',
      flex: '0 0 auto',
      '& svg': {
        fontSize: 18,
      },
      '& svg path': {
        stroke: 'inherit',
      },
    },
    navItemTitle: {
      flex: '1 1 auto',
      fontSize: 14,
      fontWeight: 500,
      overflow: 'hidden',
      textAlign: 'left',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    navItemCount: {
      alignItems: 'center',
      background: colours.brandSalmon[500],
      borderRadius: 12,
      color: colours.solid.white,
      display: 'inline-flex',
      flex: '0 0 auto',
      fontSize: 12,
      fontWeight: 600,
      height: 18,
      justifyContent: 'center',
      minWidth: 18,
      padding: spacing(0, 1.25),
    },
  });
